import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { PreSubmitIssue } from '../services/agent.service';
import { FieldIssueService } from '../services/field-issue.service';

@Directive({ selector: '[appFieldIssue]' })
export class FieldIssueDirective implements OnInit, OnDestroy {
  @Input('appFieldIssue') fieldName = '';

  private hintEl: HTMLElement | null = null;
  private sub!: Subscription;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    private fieldIssueService: FieldIssueService,
  ) {}

  ngOnInit(): void {
    this.sub = this.fieldIssueService.issues$.subscribe(issues => {
      const issue = issues.find(i => i.fieldName === this.fieldName) ?? null;
      this.render(issue);
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.clear();
  }

  private render(issue: PreSubmitIssue | null): void {
    this.clear();
    if (!issue) return;

    const div: HTMLElement = this.renderer.createElement('div');
    this.renderer.addClass(div, 'fi-hint');
    this.renderer.addClass(div, `fi-hint-${issue.severity}`);

    const iconSpan: HTMLElement = this.renderer.createElement('span');
    this.renderer.addClass(iconSpan, 'fi-hint-icon');
    this.renderer.appendChild(
      iconSpan,
      this.renderer.createText(issue.severity === 'error' ? '✕' : '⚠'),
    );
    this.renderer.appendChild(div, iconSpan);

    this.renderer.appendChild(div, this.renderer.createText(' ' + issue.issue));
    this.renderer.appendChild(this.el.nativeElement, div);
    this.hintEl = div;
  }

  private clear(): void {
    if (this.hintEl && this.el.nativeElement.contains(this.hintEl)) {
      try { this.renderer.removeChild(this.el.nativeElement, this.hintEl); } catch { /* already removed */ }
    }
    this.hintEl = null;
  }
}
